import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export const Guarantee = () => {
  const {
    t
  } = useLanguage();
  return <section className="py-8 md:py-16 bg-white" data-id="element-104">
      <div className="container mx-auto px-3 md:px-8" data-id="element-105">
        <div className="bg-blue-800 text-white py-2 md:py-3 px-4 md:px-6 rounded-t-lg inline-block mb-4 md:mb-8" data-id="element-106">
          <h2 className="text-base md:text-xl font-bold" data-id="element-107">
            {t('guarantee.header')}
          </h2>
        </div>
        <div className="bg-blue-50 p-4 md:p-8 rounded-lg flex flex-col md:flex-row items-center" data-id="element-108">
          <div className="md:w-1/4 mb-4 md:mb-0 flex justify-center" data-id="element-109">
            <ShieldCheck className="text-blue-600" size={60} data-id="element-110" />
          </div>
          <div className="md:w-3/4 md:pl-8" data-id="element-111">
            <p className="text-lg md:text-xl font-bold text-gray-800 mb-3 md:mb-4" data-id="element-112">
              {t('guarantee.title')}
            </p>
            <p className="text-base md:text-lg text-gray-700" data-id="element-113">
              {t('guarantee.description')}
            </p>
          </div>
        </div>
      </div>
    </section>;
};